import { KEYCODES } from '@fec/frontend/foundation/utils/keycodes';

export class SrfSwipeableMeteoWeek {
  constructor(el, clickCallback) {
    this.clickCallback = clickCallback;
    this.initDom(el);
    this.registerListener();
  }

  initDom(container) {
    this.$weatherWeek = container;
  }

  registerListener() {
    $('.weather-week')
      .on('click', '.weather-week__link', (e) => {
        e.preventDefault();
        let $link = $(e.currentTarget);
        if ($link.hasClass('weather-week__link--no-data')) {
          return;
        }
        $('.active')
          .removeClass('active')
          .removeAttr('aria-current')
          .find('.js-button--active')
          .addClass('h-element--hide');
        $link
          .addClass('active')
          .attr('aria-current', true)
          .find('.js-button--active')
          .removeClass('h-element--hide');

        let windowWidth = $(window).innerWidth();
        let linkPosition = $link.offset().left;
        let elementWidth = $link.width();
        let params = $link.data('href').split('/');
        params.push($link.data('index'));
        this.clickCallback(...params);

        if (windowWidth < 720) {
          let scrollDir = false;
          if (windowWidth < linkPosition + elementWidth) {
            scrollDir = '+=';
          } else if (linkPosition < 0) {
            scrollDir = '-=';
          }
          if (scrollDir) {
            this.$weatherWeek.animate(
              {
                scrollLeft: scrollDir + elementWidth, // windowWidth
              },
              400,
              'swing',
            );
          }
        }
      })
      .on('keydown', '.weather-week__link', (e) => {
        // a11y
        if (e.keyCode === KEYCODES.enter) {
          let $weatherTab = $(e.currentTarget);
          $weatherTab.click();

          if ($('.weather-week--home').length) {
            $weatherTab.attr('tabindex', -1);

            let $weatherTitle = $('.weather-title__main');
            $weatherTitle.attr('tabindex', 0).focus();

            $weatherTab.attr('tabindex', 0);
            $weatherTitle.removeAttr('tabindex');
          }

          return false;
        }
      });
  }
}
